export const MunicipalitiesData = [
  { id: '1', value: "Αποκόρωνας", item: "Αποκορώνου" },
  { id: '2', value: "Γαύδος",     item: "Γαύδου" },
  { id: '3', value: "Σέλινο", item: "Καντάνου - Σελίνου" },
  { id: '4', value: "Κίσσαμος",   item: "Κισσάμου" },
  { id: '5', value: "Πλατανιάς",   item: "Πλατανιά" },
  { id: '6', value: "Σφακιά",    item: "Σφακίων" },
  { id: '7', value: "Χανιά",     item: "Χανίων" }
]
